import { useGetIdentity } from "@pankod/refine-core";
import { useLocation } from "react-router-dom";
import { normalizeRoleType } from "accessControl";

export const useIsReadOnly = () => {
  const { data: user } = useGetIdentity();
  const { pathname } = useLocation();
  const isReader = normalizeRoleType(user) === "reader";
  const isFormPage = /\/(edit|create)(\/|$)/.test(pathname);

  return {
    isReader,
    isFormPage,
    isReadOnly: isReader,
  };
};
